import { render } from "./OtwsIndex.vue?vue&type=template&id=7f443b16&scoped=true"
import script from "./OtwsIndex.vue?vue&type=script&lang=js"
export * from "./OtwsIndex.vue?vue&type=script&lang=js"

import "./OtwsIndex.vue?vue&type=style&index=0&id=7f443b16&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f443b16"]])

export default __exports__